import React, { useState, useEffect } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";

import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import { InputAdornment, TextField } from "@mui/material";
import { SCDocumentacionModal } from "../../Dashboard/Clientes/CapturasDashClientes/DocumentadionSC/SCDocumentacionModal";
const MdlReporteCampo = ({ folio, setLoader, loader }) => {
  const [openComentarios, setOpenComentarios] = useState(false);
  const [comentarios, setComentarios] = useState("");
  const [accion, setAccion] = useState("");
  const [estatus, setEstatus] = useState({});
  const [documentoselect, setDocumentoSelect] = useState({});
  const onChange = (prop, value, sbool, smensaje) => {
    setComentarios(value);
  };
  useEffect(() => {
    onActualizarReporteCampo();
  }, []);
  const onActualizarReporteCampo = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: 6,
      responsable: "C",
    };
    request
      .post(`ADAnalisisReporteCampo`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const onEnviarComentario = () => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: 6,
      consecutivo: -1,
      comentarios,
      estatus: accion,
    };
    request
      .post("ACTimeLineComentarios", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
        setComentarios("");
        setOpenComentarios(false);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  
  const onAceptar = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      idproceso: 6,
      consecutivo: -1,
      comentarios: "REPORTE APROBADO",
      estatus: "A",
    };
    request
      .post("ACTimeLineComentarios", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
        setComentarios("");
        setOpenComentarios(false);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };
  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };
  const openModal = () => {
    var modal = document.getElementById("modal-documentos");
    modal.style.display = "block";
    setDocumentoSelect({
      documento: "REPORTE DE CAMPO",
      iddocumento: 30,
    });
  };
  return (
    <div className="analisis-credito-modal-pedido">
      <SCDocumentacionModal
        folio={folio}
        documento={documentoselect.documento}
        iddocumento={documentoselect.iddocumento}
        loader={loader}
        setLoader={setLoader}
        setdocumento={setDocumentoSelect}
        setdocumentos={onActualizarReporteCampo}
        cargar={true}
      />
      <div className="analisis-credito-modal-pedido-content">
        <div className="analisis-credito-modal-pedido-content-title">
          <div className="analisis-credito-modal-pedido-content-title-text">
            REPORTE DE CAMPO
          </div>
          <div className="analisis-credito-modal-pedido-content-title-estimate">
            TIEMPO DE RESPUESTA ESTIMADO: {estatus.tiempoestimado}
          </div>
        </div>
        {estatus.icono === "warning" && estatus.creador === true && (
          <div
            className="analisis-credito-cargar-reporte-campo"
            onClick={() => openModal()}
          >
            <CloudUploadIcon /> CARGAR REPORTE DE CAMPO
          </div>
        )}
        <div className="analisis-credito-modal-pedido-content-buttons">
          {estatus.habilitar === undefined ||
          estatus.habilitar === null ||
          estatus.habilitar === false ? (
            <></>
          ) : (
            <>
              <div
                className="analisis-credito-modal-pedido-content-acept-button"
                onClick={() => {
                  onAceptar();
                }}
              >
                <CheckCircleIcon />
                <div>ACEPTAR</div>
              </div>
              <div
                className="analisis-credito-modal-pedido-content-warning-button"
                onClick={() => {
                  setOpenComentarios(!openComentarios);
                  setAccion("M");
                }}
              >
                <WarningIcon />
                <div>SOLICITAR</div>
              </div>
              {/* <div
                className="analisis-credito-modal-pedido-content-cancel-button"
                onClick={() => {
                  setOpenComentarios(!openComentarios);
                  setAccion("R");
                }}
              >
                <CancelIcon />
                <div>RECHAZAR</div>
              </div> */}
            </>
          )}
        </div>
        {estatus.habilitar === undefined ||
          estatus.habilitar === null ||
          (estatus.habilitar === false && (
            <div
              className={`analisis-credito-modal-pedido-content-comentarios analisis-credito-modal-pedido-content-comentarios-${estatus.icono}`}
            >
              <label>Comentarios</label>
              <div className="analisis-credito-modal-pedido-content-comentarios-svg">
                <OnGetIcon icon={estatus.icono} />
              </div>
              <div className="analisis-credito-modal-pedido-content-comentarios-div">
                {estatus.comentarios}
              </div>
            </div>
          ))}
      </div>
      <div className="analisis-credito-modal-pedido-footer">
        {openComentarios && (
          <TextField
            fullWidth
            size="small"
            label="COMENTARIOS"
            className="cel-1"
            multiline
            rows={4}
            type="text"
            // error={condiciones.bcondiciones}
            onChange={({ target }) => {
              ValSpecialCharacters(
                "condiciones",
                target.value,
                onChange,
                true,
                500
              );
            }}
            value={comentarios}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <CancelScheduleSendIcon
                    onClick={() => onEnviarComentario()}
                  />
                </InputAdornment>
              ),
            }}
          />
        )}
      </div>
    </div>
  );
};

export default MdlReporteCampo;
